import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DefaultDataService,
    DefaultDataServiceConfig,
    HttpUrlGenerator,
    QueryParams
} from '@ngrx/data';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { TimecardClass } from './timecard-class.model';
import * as fromShared from '../../shared';
import * as fromErrors from '../../shared';
import { catchError, map, tap } from 'rxjs/operators';
import { EfaactDataService } from '../efaact.data-service';

export const entityName = 'TimecardClass';

@Injectable()
export class TimecardClassDataService extends EfaactDataService<TimecardClass> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: TimecardClass): TimecardClass {
        return {
            ...item,
            id: `${item.ClassListID}-${item.EmpAuthID}`
        };
    }
}
